
export const FETCH_FORCE = 'it.lacele/FETCH_FORCE'
export const FETCH_META = 'it.lacele/FETCH_META'
export const FETCH_PENDING = 'it.lacele/FETCH_PENDING'
export const FETCH_REQUIRE = 'it.lacele/FETCH_REQUIRE'
export const FETCH_UNAUTHORIZED = 'it.lacele/FETCH_UNAUTHORIZED'

export const FETCHED_CLEAR = 'it.lacele/FETCHED_CLEAR'
export const FETCHED_DATA = 'it.lacele/FETCHED_DATA'
export const FETCHED_ERROR = 'it.lacele/FETCHED_ERROR'

export const REASON_MOUNTED = 'mounted'
export const REASON_URL = 'url'
export const REASON_METHOD = 'method'
export const REASON_BODY = 'body'
export const REASON_REENABLED = 're-enabled'
export const REASON_DATA_RESET = 'data-reset'
export const REASON_XAUTHTOKEN = 'xAuthToken'
